<template>
  <enter-name v-if="enterNameStep" :next-step="nextPage" />
  <enter-email v-else-if="enterEmailStep" :next-step="nextPage" />
  <enter-phone-number v-else-if="enterPhoneNumberStep" :next-step="nextPage" />
  <signup-enter-code v-else :next="onEnterCode"/>
</template>

<script>

import GenerateCodeMixin from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup/steps/GenerateCodeMixin';
import { mapMutations } from 'vuex';
import Segment from '@/Segment';
import DDLogs from '@/DDLogs';
import SignupEnterCode from '../signup/steps/SignupEnterCode.vue';
import EnterName from './steps/EnterName';
import EnterEmail from './steps/EnterEmail';
import EnterPhoneNumber from './steps/EnterPhoneNumber';

const STEPS = { EnterNameStep: 0, EnterEmailStep: 1, EnterPhoneNumberStep: 2, EnterCodeStep: 3 };

export default {
  name: 'SignupFlowV1',
  mixins: [GenerateCodeMixin],
  components: {
    EnterName,
    EnterEmail,
    EnterPhoneNumber,
    SignupEnterCode,
  },
  data() {
    return {
      currentStep: STEPS.EnterNameStep,
    };
  },
  created() {
    Segment.trackUserGot('SignUpDetailsEntered_V1_Marketing');
    Segment.trackUserGot('SignUpDetailsEntered_Marketing');
    Segment.trackUserGotToPixel('SignUpDetailsEntered_Split');
  },
  computed: {
    enterNameStep() {
      return this.currentStep === STEPS.EnterNameStep;
    },
    enterEmailStep() {
      return this.currentStep === STEPS.EnterEmailStep;
    },
    enterPhoneNumberStep() {
      return this.currentStep === STEPS.EnterPhoneNumberStep;
    },
  },
  methods: {
    ...mapMutations('signup', ['resetError']),
    nextPage() {
      this.currentStep += 1;
    },
    async generateCodeAndProceed(firstName, lastName, phoneNumber, email, enableMarketingEmails) {
      await this.generateCodeForSignup(firstName, lastName, phoneNumber, email, enableMarketingEmails);
      this.currentStep = STEPS.EnterCodeStep;
    },
    onEnterCode() {
      Segment.trackUserGot('2faRedirectToAuth0Signup');
      DDLogs.log('Customer redirect to Auth0Signup flow');
      window.location.href = '/api/partial-auth/login-with-auth0/new';
    },
    goToLogin() {
      window.location.href = '/sr';
    },
  },
};
</script>
